import { FC } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormField, { IProps } from './FormField';

interface IOptions {
	label: string | number | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
	value: unknown;
}

interface IFormFieldCheckBox extends Omit<IProps, 'children'> {
	options: IOptions[];

	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void;
}

const FormFieldCheckBox: FC<IFormFieldCheckBox> = ({
	error,
	helperText,
	id,
	label,
	options,
	onChange,
	onBlur,
	topLabel,
	fillWidth,
}) => {
	return (
		<FormField error={error} helperText={helperText} id={id} label={label} topLabel={topLabel} fillWidth={fillWidth}>
			<Box sx={{ display: 'flex', gap: 2 }}>
				{options.map((option) => (
					<FormControlLabel
						key={option.value as string}
						sx={{ textAlign: 'left' }}
						control={
							<Checkbox
								icon={<CircleOutlinedIcon color={error ? 'error' : undefined} />}
								onChange={onChange}
								onBlur={onBlur}
								checkedIcon={<CheckCircleIcon />}
								value={option.value}
								sx={{
									'& .MuiSvgIcon-root': { fontSize: '4rem' },
								}}
								slotProps={{ input: { 'aria-label': 'controlled' } }}
								checked={Boolean(option.value)}
							/>
						}
						label={option.label}
					/>
				))}
			</Box>
		</FormField>
	);
};

export default FormFieldCheckBox;
